import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@env';
import { MaterialModule } from '../core/material.module';
import { SystemVersionUpdateDialogComponent } from './dialogs/system-version-update-dialog/system-version-update-dialog.component';
import {
    InitialSystemVersionServiceFactory,
    SystemVersionService
} from './services/system-version.service';

// Create a Trusted Types policy if supported
const serviceWorkerUrl = (() => {
    if (window.trustedTypes) {
        const policy = window.trustedTypes.createPolicy(
            'service-worker-policy',
            {
                createScriptURL: url => url
            }
        );
        return policy.createScriptURL('safety-worker.js').toString(); // Convert to string
    }
    return 'safety-worker.js'; // Fallback for unsupported environments
})();

@NgModule({
    imports: [
        CommonModule,

        ServiceWorkerModule.register(serviceWorkerUrl, {
            enabled: environment.production,
            // try register immediately
            registrationStrategy: 'registerWhenStable:3000'
        }),

        //Material
        MaterialModule
    ],
    declarations: [SystemVersionUpdateDialogComponent],
    providers: [
        SystemVersionService,
        {
            provide: APP_INITIALIZER,
            useFactory: InitialSystemVersionServiceFactory,
            deps: [SystemVersionService],
            multi: true
        }
    ],
    exports: [MatIconModule]
})
export class SystemVersionModule {}
